export const filterOutrightsMarkets = (outrights, markets, events) => {
    return markets.filter((market) => {
        return outrights
            ? !!events.find(ev => ev.id === market.id)
            : !events.find(ev => (ev.id === market.id));
    });
};
//# sourceMappingURL=filterOutrightsMarkets.js.map